import { dispatch } from 'api/redux'
import { setGradeConfigs, setGradeReasonProperties } from 'api/redux/store/application.actions'
import { type GradeKey, type GradeConfig, type GradeReasonProperties } from 'types'

import { mainSplitApi } from './redux/mainSplitApi'

export interface GradePropertiesQueryParams {
  division?: string
}

export const gradePropertiesApi = mainSplitApi.injectEndpoints({
  endpoints: (builder) => ({
    getGradeProperties: builder.query<GradeReasonProperties[], GradePropertiesQueryParams | void>({
      query: (params) => {
        const queryParams = params?.division ? `?division=${params.division}` : ''
        return {
          url: `/units/gradeproperties${queryParams}`,
          method: 'GET'
        }
      },
      transformResponse: (response: GradeReasonProperties[]) => {
        const configMap = new Map<GradeKey, GradeConfig>()
        response.forEach(gradeProperty => {
          const needsReason = response.some((item) => item.grade === gradeProperty.grade && item.reason && item.reason !== '')
          const key = gradeProperty.grade.toUpperCase() as GradeKey
          configMap.set(key, {
            key,
            display: gradeProperty.display,
            needsReason,
            qualityCode: gradeProperty.qualityCode
          })
        })
        dispatch(setGradeConfigs(Array.from(configMap.values())))
        dispatch(setGradeReasonProperties(response))
        return response
      }
    })
  }),
  overrideExisting: false
})

export const { useGetGradePropertiesQuery, useLazyGetGradePropertiesQuery } = gradePropertiesApi
